import { PageHeading, Pagination } from 'components/atoms';
import { Head, PageLayout } from 'components/molecules';
import EintragungenList from 'components/molecules/Eintragungen/EintragungenList/Eintragungenlist';
import EintragungenFilter from 'components/molecules/Eintragungen/Filter/EintragungenFilter';
import { getTranslations } from 'i18n';
import type { GetServerSideProps, NextPage } from 'next';
import React from 'react';
import { ISO8601Date } from 'types';
import type { Eintragung } from 'types/eintragungen';
import { getCanonicalUrl } from 'utils';
import { useTranslation } from 'utils/hooks';
import { getEintragungen } from 'utils/listStaticProps';


interface NeueintragungenPageProps
{
  limit: number;
  page: number;
  total: number;
  aktuell: ISO8601Date;
  filters: Record<string, string>;
  neueintragungen: Eintragung[];
}

const NeueintragungenPage: NextPage<NeueintragungenPageProps> = (props) =>
{
  const { filters, neueintragungen, page, limit, total, aktuell } = props;
  const { t } = useTranslation();

  return (
    <PageLayout>

      <Head
        title={t('eintragungen:neueintragungen.seoTitle')}
        description={t('eintragungen:neueintragungen.seoDescription')}
      >
        <link rel="canonical" href={`${getCanonicalUrl()}/l/neueintragungen`}/>
      </Head>

      <EintragungenFilter
        defaultValues={filters}
        aktuell={aktuell}
        eintragungsart={'neueintragungen'}
        dateOptions={[3, 7, 14, 21, 30]}
      />

      <PageHeading title={t('eintragungen:neueintragungen.heading', { count: total })}/>

      <EintragungenList
        eintragungen={neueintragungen}
      />

      {neueintragungen.length > 0 && (
        <Pagination
          activePage={page}
          limit={limit}
          totalResults={total}
          shallow={false}
          scrollTop
        />
      )}

    </PageLayout>
  );
};

export default NeueintragungenPage;

export const getServerSideProps: GetServerSideProps = async (ctx) => 
{
  const { locale } = ctx;
  const translations = await getTranslations(locale, 'common', 'eintragungen', 'bundesländer');
  const props = await getEintragungen(ctx, 'neueintragungen');

  return { props: { ...props, ...translations } };
};